import React, {useMemo} from 'react';

export function DhcdPagination({page, totalPages, goto}) {
    const canPrev = page > 1;
    const canNext = page < totalPages;
    const maxVisible = 5;

    const pages = useMemo(() => {
        let start = Math.max(1, page - Math.floor(maxVisible / 2));
        let end = start + maxVisible - 1;

        if (end > totalPages) {
            end = totalPages;
            start = Math.max(1, end - maxVisible + 1);
        }

        return Array.from({length: end - start + 1}, (_, i) => start + i);
    }, [page, totalPages]);

    return (
        <div className="dhcd-pagination">
            {/* Prev */}
            <button
                type="button"
                className={`page-btn ${!canPrev ? 'disabled' : ''}`}
                aria-label="Trang trước"
                onClick={() => canPrev && goto(page - 1)}
                disabled={!canPrev}>
                <img src="/bw_image/chevron-left-share.svg" alt="" />
            </button>

            {/* Page dots */}
            {pages.map(p => (
                <button
                    type="button"
                    key={p}
                    className={`page-dot ${page === p ? 'active' : ''}`}
                    aria-label={`Trang ${p}`}
                    aria-current={page === p ? 'page' : undefined}
                    onClick={() => goto(p)}>
                    {p}
                </button>
            ))}

            {/* Next */}
            <button
                type="button"
                className={`page-btn ${!canNext ? 'disabled' : ''}`}
                aria-label="Trang sau"
                onClick={() => canNext && goto(page + 1)}
                disabled={!canNext}>
                <img src="/bw_image/chevron-right-share.svg" alt="" />
            </button>
        </div>
    );
}
